
import React from "react";
import { Button } from "@/components/ui/button";
import { LayoutGrid, List, Table2 } from "lucide-react";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Toggle } from "@/components/ui/toggle";

export type ViewType = "table" | "card" | "list";

interface ViewSwitcherProps {
  currentView: ViewType;
  onViewChange: (view: ViewType) => void;
}

export function ViewSwitcher({ currentView, onViewChange }: ViewSwitcherProps) {
  return (
    <div className="flex items-center space-x-2">
      <Toggle
        pressed={currentView === "table"}
        onPressedChange={() => onViewChange("table")}
        aria-label="Table view"
        title="Table view"
        size="sm"
        variant={currentView === "table" ? "default" : "outline"}
        className={currentView === "table" ? "bg-primary text-primary-foreground" : ""}
      >
        <Table2 className="h-4 w-4" />
      </Toggle>
      
      <Toggle
        pressed={currentView === "card"}
        onPressedChange={() => onViewChange("card")}
        aria-label="Card view"
        title="Card view"
        size="sm"
        variant={currentView === "card" ? "default" : "outline"}
        className={currentView === "card" ? "bg-primary text-primary-foreground" : ""}
      >
        <LayoutGrid className="h-4 w-4" />
      </Toggle>
      
      <Toggle
        pressed={currentView === "list"}
        onPressedChange={() => onViewChange("list")}
        aria-label="List view"
        title="List view"
        size="sm"
        variant={currentView === "list" ? "default" : "outline"}
        className={currentView === "list" ? "bg-primary text-primary-foreground" : ""}
      >
        <List className="h-4 w-4" />
      </Toggle>
    </div>
  );
}

// For backward compatibility, make the component work with viewType prop as well
export function ViewSwitcherAdapter(props: any) {
  // If viewType is passed, use it as currentView
  if ('viewType' in props) {
    return <ViewSwitcher currentView={props.viewType} onViewChange={props.onViewChange} />;
  }
  return <ViewSwitcher {...props} />;
}
